import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { ParentGate } from "../ParentGate";
import { play } from "../../lib/audio";

const LESSON_COPY = { title: "這是完整版的課程", desc: "請爸爸媽媽打開 Premium，就能學到所有故事和課程喔！", later: "先玩免費的課" };

export const usePremiumPrompt = (copy = LESSON_COPY) => {
  const [open, setOpen] = useState(false);
  const [gate, setGate] = useState(false);
  const nav = useNavigate();
  const prompt = () => { play(`${copy.title}，請爸爸媽媽來看看喔`); setOpen(true); };
  const element = (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-3xl border-4 border-amber-200 text-center font-round" data-testid="premium-dialog">
          <div className="mx-auto w-20 h-20 rounded-full bg-amber-100 border-4 border-amber-300 flex items-center justify-center"><Crown size={40} className="text-amber-500" /></div>
          <DialogTitle className="text-3xl text-[var(--tea)]">{copy.title}</DialogTitle>
          <DialogDescription className="text-lg text-stone-600">{copy.desc}</DialogDescription>
          <div className="grid gap-3 mt-2">
            <button data-testid="premium-dialog-parent-btn" onClick={() => { setOpen(false); setGate(true); }} className="kid-btn bg-[var(--vermilion)] text-white text-xl">請爸爸媽媽來看看</button>
            <button data-testid="premium-dialog-close-btn" onClick={() => setOpen(false)} className="kid-btn bg-white border-2 border-[var(--line)] text-[var(--tea)] text-xl">{copy.later}</button>
          </div>
        </DialogContent>
      </Dialog>
      <ParentGate open={gate} onOpenChange={setGate} onPass={() => nav("/pricing")} />
    </>
  );
  return [prompt, element];
};

export const CrownBadge = ({ size = 22, className = "" }) => <Crown size={size} className={`text-amber-500 ${className}`} fill="#fde68a" />;
